module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#rss",
      toString: function () {
        return this.url;
      }
    }